<template>
  <transition name="fade">
    <div class="flex flex-col items-center justify-center absolute w-full h-full pin-y pin-l z-1010 bg-overlay p-2" ref="modal" @keyup.esc="close" tabindex="0">
      <div class="rounded bg-white relative p-4 w-full" :class="[heightClass]">
        <div class="absolute pin-t pin-r mr-2 mt-2 cursor-pointer" @click="close">
          <v-icon scale="1" class="self-center" name="times" color="#6f6f70" />
        </div>
        <div class="">
          <div class="flex justify-between">
            <div class="flex flex-col">
              <div class="text-grey-darkest text-sm font-bold">{{ recap.nama_sekolah }}</div>
              <div class="text-grey-darkest text-sm">{{ recap.nama_kecamatan }}</div>
              <div class="text-grey-darkest text-sm">{{ recap.nama_kabkota }}</div>
              <div class="text-grey-darkest text-sm">{{ recap.nama_provinsi }}</div>
            </div>
            <div class="self-end">
              <pagination v-if="paginationData.lastPage > 1" :pagination="paginationData" :offset="offset" @paginate="changePage()"></pagination>
            </div>
          </div>

          <div class="text-grey-darker text-sm mt-2 overflow-x-auto overflow-y-auto h-full flex">
            <table class="table-auto w-full">
              <thead class="text-center">
                <tr>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" rowspan="3">Mata Pelajaran</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" colspan="6">Jumlah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" rowspan="2" colspan="2">Keterangan</th>
                </tr>
                <tr>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" colspan="2">Saat Ini</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" colspan="2">Kebutuhan</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light" colspan="2">Selisih</th>
                </tr>
                <tr>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sebelum</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sesudah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sebelum</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sesudah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sebelum</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sesudah</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sebelum</th>
                  <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sesudah</th>
                </tr>
              </thead>
              <tbody class="text-left" v-if="recap.course.length">
                <tr class="hover:bg-blue-lightest" v-for="(recapDatum, index) in recapData" :key="index">
                  <td class="p-1 border border-grey-light whitespace-no-wrap">{{ recapDatum.course }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.nowBefore }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.nowAfter }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.needsBefore }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.needsAfter }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.diffBefore }}</td>
                  <td class="p-1 border border-grey-light text-center">{{ recapDatum.diffAfter }}</td>
                  <td class="p-1 border border-grey-light text-center" :class="bgColor(recapDatum.statusBefore)">{{ recapDatum.statusBefore }}</td>
                  <td class="p-1 border border-grey-light text-center" :class="bgColor(recapDatum.statusAfter)">{{ recapDatum.statusAfter }}</td>
                </tr>
              </tbody>
              <tbody class="text-left" v-else>
                <tr class="hover:bg-blue-lightest">
                  <td class="p-1 border border-grey-light text-center" colspan="9">Tidak ada data</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_RECAP_SCHOOL
} from '@/mutationTypes'
import Pagination from '@/components/Pagination'

export default {
  name: 'modal-recap',
  components: {
    pagination: Pagination
  },
  mounted () {
    this.$nextTick(() => this.$refs.modal.focus())
    this.recap.nama_sekolah = this.selectedSchool.properties.nama
    // console.log(this.selectedProvince.nama)
    this.recap.nama_provinsi = this.selectedProvince.nama
    this.fetchRecap()
  },
  computed: {
    ...mapState(['selectedSchool', 'selectedProvince'])
  },
  data () {
    return {
      recap: {
        'sekolah_id': '',
        'kode_wilayah': '',
        'kode_kabkota': '',
        'kode_wilayah_propinsi': '',
        'nama_kecamatan': '',
        'nama_kabkota': '',
        'nama_provinsi': '',
        'nama_sekolah': '',
        course: [],
        before: {
          teacher: []
        },
        after: {
          teacher: []
        }
      },
      limit: 10,
      offset: 10,
      paginationData: {
        currentPage: 1
      },
      recapData: []
    }
  },
  methods: {
    close () {
      this.$store.dispatch(TOGGLE_MODAL_RECAP_SCHOOL, false)
    },
    async fetchRecap () {
      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/comparationTable/' + this.selectedSchool.properties.sekolah_id)
        let json = await response.json()
        // console.log(json)
        if (json.status === 200) {
          this.recap = json.result
          this.paginationData.total = this.recap.course.length
          this.paginationData.lastPage = Math.ceil(this.paginationData.total / this.limit)
          this.paginationData.perPage = this.limit
          this.paginationData.from = 1
          this.paginationData.to = this.limit
          if (this.paginationData.currentPage === this.paginationData.lastPage) {
            this.paginationData.to = this.paginationData.total
          }
          this.renderData()
        }
      } catch (err) {
        // console.log(err)
      }
    },
    renderData () {
      let result = []
      for (let index = this.paginationData.from - 1; index < this.paginationData.to; index++) {
        result.push({
          course: this.recap.course[index],
          nowBefore: this.recap.before.teacher[index].sekarang,
          nowAfter: this.recap.after.teacher[index].sekarang,
          needsBefore: this.recap.before.teacher[index].kebutuhan,
          needsAfter: this.recap.after.teacher[index].kebutuhan,
          diffBefore: this.recap.before.teacher[index].selisih,
          diffAfter: this.recap.after.teacher[index].selisih,
          statusBefore: this.recap.before.teacher[index].kondisi,
          statusAfter: this.recap.after.teacher[index].kondisi
        })
      }
      this.recapData = result
    },
    changePage () {
      this.paginationData.from = (this.paginationData.currentPage - 1) * this.limit + 1
      this.paginationData.to = this.paginationData.currentPage * this.limit
      if (this.paginationData.currentPage === this.paginationData.lastPage) {
        this.paginationData.to = this.paginationData.total
      }
      this.renderData()
    },
    heightClass () {
      switch (this.selectedSchool.properties.bentuk) {
        case 'SD':
          return 'h-48'
        case 'SMP':
          return 'h-128'
        case 'SMA':
          return 'h-144'
        default:
          return 'h-128'
      }
    },
    bgColor (condition) {
      switch (condition) {
        case 'Sesuai':
          return 'bg-success-light'
        case 'Kurang':
          return 'bg-cta-light'
        case 'Lebih':
          return 'bg-warning-light'
        default:
          return ''
      }
    }
  }
}
</script>
